import styled from 'styled-components'
import { colors, TYPOGRAPHY } from 'styles'

export const Title = styled.h4`
  font-size: ${TYPOGRAPHY.size.xxxs};
  font-weight: normal;
  color: ${colors.content.subdued};
  font-family: ${TYPOGRAPHY.primary};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0.5rem 1rem 0.25rem;
`
